import React from 'react'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'

import { Helmet } from 'components/UI'

import styles from './404.module.scss'

const NotFound = ({ title, description, fallbackTitle, fallbackLink }) => {
  const intl = useIntl()

  const pageTitle = title ?? intl.formatMessage({ id: 'page404.title' })

  return (
    <div className={styles.container}>
      <Helmet title={pageTitle} />
      <div className={styles.box}>
        <div className={styles.inner}>
          <h1 className="font-size-36 mb-2">{pageTitle}</h1>
          <p className="mb-3">{description ?? intl.formatMessage({ id: 'page404.description' })}</p>
          <h1 className="font-size-80 mb-4 font-weight-bold">404 —</h1>
          <Link to={fallbackLink ?? '/'} className="btn">
            &larr; {fallbackTitle ?? intl.formatMessage({ id: 'page404.fallback' })}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
